// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { MyListsPageContext } from "@insite/content-library/Pages/MyListsPage";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface MyListsHeaderStyles {
    container?: InjectableCss;
    searchGrid?: InjectableCss;
    sortGrid?: InjectableCss;
    createListGrid?: InjectableCss;
}

export const headerStyles: MyListsHeaderStyles = {
    container: {
        css: css`
            display: flex;
            flex-wrap: wrap;
        `,
    },
    searchGrid: {
        css: css`
            width: 290px;
            margin-right: 30px;
            display: flex;
            align-items: center;
            @media (max-width: 650px) {
                width: 100%;
                margin-right: 0;
                margin-bottom: 15px;
                order: 3;
            }
        `,
    },
    sortGrid: {
        css: css`
            width: 230px;
            display: flex;
            align-items: center;
            @media (max-width: 650px) {
                width: 100%;
                margin-bottom: 15px;
                order: 4;
            }
        `,
    },
    createListGrid: {
        css: css`
            flex-grow: 1;
            @media (max-width: 650px) {
                margin-bottom: 15px;
                order: 1;
            }
        `,
    },
};

const styles = headerStyles;

const MyListsHeader: React.FC<WidgetProps> = props => {
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.searchGrid}>
                <Zone contentId={props.id} zoneName="Content01" />
            </StyledWrapper>
            <StyledWrapper {...styles.sortGrid}>
                <Zone contentId={props.id} zoneName="Content10" />
            </StyledWrapper>
            <StyledWrapper {...styles.createListGrid}>
                <Zone contentId={props.id} zoneName="Content11" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: MyListsHeader,
    definition: {
        group: "My Custom Quotes" as any,
        displayName: "Custom Quote Options Container",
        allowedContexts: ["MyCustomQuotesPage" as any],
    },
};

export default widgetModule;
